import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
const optionsAlingText = [
  { value: 'left', label: 'Izquierda' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Derecha' },
]

const Button = ({ index, control, handleDeleteItem }) => {
  return (
    <Box
      title="Item"
      contentHeader={
        <>
          <h3 className="card-title pl-3 mt-0">Item</h3>
          <div className="card-tools mr-2">
            <button
              type="button"
              className="btn btn-sm btn-migrates"
              title="Eliminar item"
              onClick={() => handleDeleteItem({ index })}
            >
              <i className="fas fa-trash-alt" />
            </button>
          </div>
        </>
      }
      content={
        <div className="d-flex flex-wrap" style={{ gap: '20px 20px' }}>
          <div className="">
            <InputController
              label="Texto Español"
              name={`button[${index}].text_es`}
              type="text"
              placeholderTxt="Escribe texto español"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Texto Ingles"
              name={`button[${index}].text_en`}
              type="text"
              placeholderTxt="Escribe texto ingles"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Link"
              name={`button[${index}].link`}
              type="text"
              placeholderTxt="Escribe link"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Color de texto"
              name={`button[${index}].textColor`}
              type="text"
              placeholderTxt="Escribe"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Color de fondo"
              name={`button[${index}].backgroundColor`}
              type="text"
              placeholderTxt="Escribe"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Alineación icono"
              name={`button[${index}].icon_direction`}
              control={control}
              inputType="choosen"
              options={optionsAlingText}
              placeholderTxt="Elige uno"
              isClearable={true}
            />
          </div>
          <div className="">
            <InputController
              label="Fontawesome icon"
              name={`button[${index}].icon_fontawesome`}
              type="text"
              placeholderTxt="Escribe nombre icono"
              control={control}
            />
          </div>
          <div className="">
            <InputController
              label="Url icon"
              name={`button[${index}].icon_url`}
              type="text"
              placeholderTxt="Escribe url icono"
              control={control}
            />
          </div>
        </div>
      }
    />
  )
}

export default Button
